import { styled } from '@linaria/react';

import { Skeleton } from '~/shared/ui/lib/Skeleton';

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CardSkeleton = styled(Skeleton)`
  width: 100%;
  aspect-ratio: 197 / 136;
`;

export const BarSkeleton = styled(Skeleton)`
  width: 100%;
  height: 16px;
  margin: 8px 0;
`;
